var _rect, _rect2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteReplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 6,
    height: 6,
    rx: 1,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 6,
    height: 6,
    rx: 1,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11C20 11.5523 20.4477 12 21 12C21.5523 12 22 11.5523 22 11H20ZM13 6V5C12.5955 5 12.2309 5.24364 12.0761 5.61732C11.9213 5.99099 12.0069 6.42111 12.2929 6.70711L13 6ZM15.2929 9.70711C15.6834 10.0976 16.3166 10.0976 16.7071 9.70711C17.0976 9.31658 17.0976 8.68342 16.7071 8.29289L15.2929 9.70711ZM16.7071 3.70711C17.0976 3.31658 17.0976 2.68342 16.7071 2.29289C16.3166 1.90237 15.6834 1.90237 15.2929 2.29289L16.7071 3.70711ZM12.2929 5.29289C11.9024 5.68342 11.9024 6.31658 12.2929 6.70711C12.6834 7.09763 13.3166 7.09763 13.7071 6.70711L12.2929 5.29289ZM22 11V8H20V11H22ZM22 8C22 6.34315 20.6569 5 19 5V7C19.5523 7 20 7.44772 20 8H22ZM19 5H13V7H19V5ZM12.2929 6.70711L15.2929 9.70711L16.7071 8.29289L13.7071 5.29289L12.2929 6.70711ZM15.2929 2.29289L12.2929 5.29289L13.7071 6.70711L16.7071 3.70711L15.2929 2.29289Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13C4 12.4477 3.55228 12 3 12C2.44772 12 2 12.4477 2 13H4ZM11 18V19C11.4045 19 11.7691 18.7564 11.9239 18.3827C12.0787 18.009 11.9931 17.5789 11.7071 17.2929L11 18ZM8.70711 14.2929C8.31658 13.9024 7.68342 13.9024 7.29289 14.2929C6.90237 14.6834 6.90237 15.3166 7.29289 15.7071L8.70711 14.2929ZM7.29289 20.2929C6.90237 20.6834 6.90237 21.3166 7.29289 21.7071C7.68342 22.0976 8.31658 22.0976 8.70711 21.7071L7.29289 20.2929ZM11.7071 18.7071C12.0976 18.3166 12.0976 17.6834 11.7071 17.2929C11.3166 16.9024 10.6834 16.9024 10.2929 17.2929L11.7071 18.7071ZM2 13V16H4V13H2ZM2 16C2 17.6569 3.34315 19 5 19V17C4.44772 17 4 16.5523 4 16H2ZM5 19H11V17H5V19ZM11.7071 17.2929L8.70711 14.2929L7.29289 15.7071L10.2929 18.7071L11.7071 17.2929ZM8.70711 21.7071L11.7071 18.7071L10.2929 17.2929L7.29289 20.2929L8.70711 21.7071Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteReplace);
export default __webpack_public_path__ + "static/media/WhiteReplace.575b49a6e8f63d4ead2ef0d7dfe46bb3.svg";
export { ForwardRef as ReactComponent };